<template>
  <div class="retain-info">
    <portal to="layout-nav-title">{{$t('wechatMiniProgram.analysis.retainInfo')}}</portal>

    <div>
      <h2>{{$t('wechatMiniProgram.analysis.daily')}}</h2>
      <el-date-picker
        v-model="dailyDate"
        type="date"
        @change="dailyDateChange"
        :picker-options="dailyPickerOptions"
        :placeholder="$t('wechatMiniProgram.analysis.pleaseSelectDate')">
      </el-date-picker>
      <bean-export-button v-bind="dailyExportButtonProps" style="margin-left: 20px;" />
      <div class="info-table">
        <Table
          :value="newUvdailyRetainData('daily')"
          :columns="retainInfoColumns($t('wechatMiniProgram.analysis.retentionUvNew'), 'Day')"
        />
        <Table
          :value="UvdailyRetainData('daily')"
          :columns="retainInfoColumns($t('wechatMiniProgram.analysis.retentionUvActive'), 'Day')"
        />
      </div>
    </div>

    <div>
      <h2>{{$t('wechatMiniProgram.analysis.weekly')}}</h2>
      <el-date-picker
        v-model="weeklyDate"
        type="week"
        :format="$t('wechatMiniProgram.analysis.weeklyFormat')"
        @change="weeklyDateChange"
        :picker-options="weeklyPickerOptions"
        :placeholder="$t('wechatMiniProgram.analysis.pleaseSelectWeek')">
      </el-date-picker>
      <bean-export-button v-bind="weeklyExportButtonProps" style="margin-left: 20px;" />
      <div class="info-table">
        <Table
          :value="newUvdailyRetainData('weekly')"
          :columns="retainInfoColumns($t('wechatMiniProgram.analysis.retentionUvNew'), 'Week')"
        />
        <Table
          :value="UvdailyRetainData('weekly')"
          :columns="retainInfoColumns($t('wechatMiniProgram.analysis.retentionUvActive'), 'Week')"
        />
      </div>
    </div>

    <div>
      <h2>{{$t('wechatMiniProgram.analysis.monthly')}}</h2>
      <el-date-picker
        v-model="monthlyDate"
        type="month"
        @change="monthlyDateChange"
        :picker-options="monthlyPickerOptions"
        :placeholder="$t('wechatMiniProgram.analysis.pleaseSelectMonth')">
      </el-date-picker>
      <bean-export-button v-bind="monthlyExportButtonProps" style="margin-left: 20px;" />
      <div class="info-table">
        <Table
          :value="newUvdailyRetainData('monthly')"
          :columns="retainInfoColumns($t('wechatMiniProgram.analysis.retentionUvNew'), 'Month')"
        />
        <Table
          :value="UvdailyRetainData('monthly')"
          :columns="retainInfoColumns($t('wechatMiniProgram.analysis.retentionUvActive'), 'Month')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';
import Table from 'beans-admin-plugin/components/table';
import _ from 'lodash';

@Component({
  components: {
    Table
  }
})
export default class RetainInfo extends Vue {
  dailyDate = moment().add('days', -1);
  weeklyDate = moment().add('weeks', -1).endOf('week');
  monthlyDate = moment().add('months', -1).endOf('month');

  data = {
    daily_retain_info: [],
    monthly_retain_info: [],
    weekly_retain_info: []
  }

  get dailyPickerOptions() {
    return {
      disabledDate: (time) => {
        return moment(time).diff(moment(new Date()), 'days') > -1
      }
    }
  }

  get weeklyPickerOptions() {
    return {
      disabledDate: (time) => {
        return moment(time).diff(moment(new Date()), 'weeks') > -1
      },
      // 一周开始日期，为周一日期
      firstDayOfWeek: 1
    }
  }

  get monthlyPickerOptions() {
    return {
      disabledDate: (time) => {
        return moment(time).diff(moment(new Date()), 'months') > -1
      }
    }
  }

  newUvdailyRetainData(time) {
    return _.get(this.data, `${time}_retain_info.visit_uv_new`) || [];
  }

  UvdailyRetainData(time) {
    return _.get(this.data, `${time}_retain_info.visit_uv`) || [];
  }

  retainInfoColumns(zeroKey, unit) {
    return [
      {
        prop: 'key',
        label: this.$t('wechatMiniProgram.analysis.time'),
        width: 200,
        renderCell: (h, { props: { value } }) => {
          return <span>{ value === 0 ? zeroKey : this.$t(`wechatMiniProgram.analysis.time${unit}Later`, { value: value }) }</span>;
        }
      },
      {
        prop: 'value',
        label: `${zeroKey}/${this.$t('wechatMiniProgram.analysis.retainedUsers')}`,
        width: 200
      }
    ]
  }

  async mounted() {
    const [dailyRetainInfo, weeklyRetainInfo, monthlyRetainInfo] = await Promise.all(
      [
        this.fetchDailyData(),
        this.fetchWeeklyData(),
        this.fetchMonthlyData()
      ]
    )
    this.data.daily_retain_info = dailyRetainInfo;
    this.data.weekly_retain_info = weeklyRetainInfo;
    this.data.monthly_retain_info = monthlyRetainInfo;
  }

  dateRangeParams(type) {
    if (type === 'daily') {
      const formatTime = moment(this.dailyDate).format('YYYY-MM-DD')
      return { begin_date: formatTime, end_date: formatTime };
    } else if (type === 'weekly') {
      return { begin_date: moment(this.weeklyDate).startOf('week').add('days', 1).format('YYYY-MM-DD'), end_date: moment(this.weeklyDate).endOf('week').add('days', 1).format('YYYY-MM-DD') }
    } else {
      return { begin_date: moment(this.monthlyDate).startOf('month').format('YYYY-MM-DD'), end_date: moment(this.monthlyDate).endOf('month').format('YYYY-MM-DD')  };
    }
  }

  async fetchDailyData() {
    if (this.dailyDate) {
      return await this.$request.get(`applications/${'wx8bb4a20e2f302ca3'}/analyses/getweanalysisappiddailyretaininfo`, this.dateRangeParams('daily'));
    } else {
      this.$message.warning(this.$t('wechatMiniProgram.analysis.pleaseSelectDate'));
    }
  }

  async fetchWeeklyData() {
    if (this.weeklyDate) {
      return await this.$request.get(`applications/${'wx8bb4a20e2f302ca3'}/analyses/getweanalysisappidweeklyretaininfo`, this.dateRangeParams('weekly'));
    } else {
      this.$message.warning(this.$t('wechatMiniProgram.analysis.pleaseSelectWeek'));
    }
  }

  async fetchMonthlyData() {
    if (this.monthlyDate) {
      return await this.$request.get(`applications/${'wx8bb4a20e2f302ca3'}/analyses/getweanalysisappidmonthlyretaininfo`, this.dateRangeParams('monthly'));
    } else {
      this.$message.warning(this.$t('wechatMiniProgram.analysis.pleaseSelectMonth'));
    }
  }

  async dailyDateChange() {
    this.data.daily_retain_info = await this.fetchDailyData();
  }

  async weeklyDateChange() {
    this.data.weekly_retain_info = await this.fetchWeeklyData();
  }

  async monthlyDateChange() {
    this.data.monthly_retain_info = await this.fetchMonthlyData();
  }

  get dailyExportButtonProps() {
    return {
      url: '/export_analyses/getweanalysisappiddailyretaininfo',
      params: this.dateRangeParams('daily'),
      fileName: `${this.$t('wechatMiniProgram.analysis.retainInfo')}-${this.$t('wechatMiniProgram.analysis.daily')}.xlsx`,
    }
  }

  get weeklyExportButtonProps() {
    return {
      url: '/export_analyses/getweanalysisappidweeklyretaininfo',
      params: this.dateRangeParams('weekly'),
      fileName: `${this.$t('wechatMiniProgram.analysis.retainInfo')}-${this.$t('wechatMiniProgram.analysis.weekly')}.xlsx`,
    }
  }

  get monthlyExportButtonProps() {
    return {
      url: '/export_analyses/getweanalysisappidmonthlyretaininfo',
      params: this.dateRangeParams('monthly'),
      fileName: `${this.$t('wechatMiniProgram.analysis.retainInfo')}-${this.$t('wechatMiniProgram.analysis.monthly')}.xlsx`,
    }
  }
}

export const route = [
  {
    path: '/retain_info',
    name: 'retain_info',
    component: RetainInfo,
    meta: {
      can: 'data_analyses.retain_info'
    }
  }
]
</script>

<style lang="scss" scoped>
.retain-info {
  margin-left: 20px;

  .el-date-editor {
    margin-bottom: 20px;
  }

  .info-table {
    display: flex;

    .el-table {
      max-width: 400px;
      min-height: 200px;
      margin: 0 20px 20px 0;

      .el-table__header-wrapper, .el-table__body-wrapper {
        width: 400px;
      }
    }
  }
}
</style>
